<ion-card
  value="order-history"
  class="oh-card card-white-background-color grey-border no-shadow ion-no-margin marb10"
>
  <div class="order" value="open">
    <ion-item lines="none" class="ion-no-padding ion-no-margin pad10" slot="header">
      <ion-thumbnail slot="start">
        <img
          [alt]="orderDetail?.storeImage || imagePlaceholder"
          [src]="orderDetail?.storeImage || imagePlaceholder"
        />
      </ion-thumbnail>
      <ion-label class="padr10">
        <h3 class="fs-2 font700 title-text-color mar0">
          {{ orderDetail?.storeName }}
        </h3>
        <p class="fs-1 font500 dutyfree-text-secondary mar0 mart4">
          {{ orderDate | smartdate : "mediumDate" }}
        </p>
      </ion-label>
      <ion-chip
        class="ion-no-margin ion-no-padding fs-1 font500 ion-justify-content-center"
        [ngClass]="
          orderDetail.status === 'Cancelled'
            ? 'grey-danger-chip'
            : 'grey-primary-chip'
        "
      >
        {{ orderDetail.status }}
      </ion-chip>
      <ion-icon
        name="chevron-forward-outline"
        class="padl10 arrow-icon dutyfree-text-muted"
      ></ion-icon>
    </ion-item>
  </div>
</ion-card>
